import { useWeb3Store } from "@/store/web3";
import { useInfoReaderContract } from "@/web3/contracts";
import { useAnyApi } from "@/api/useAnyApi";
import { fetchPartnerTokens } from "./fetchPartners";
import { fetchBotbTokens } from "./fetchBotb";
import { fetchTeens } from "./fetchTeens";
import { fetchGenesis } from "./fetchGenesis";
import { fetchUtilities } from "./fetchUtilities";
import { fetchApes } from "./fetchApes";
import { fetchClues } from "./fetchClues";

export const fetchCollection = async () => {
  const web3Store = useWeb3Store();
  let wallet = web3Store.collectionWallet;
  const infoReader = useInfoReaderContract();
  const bapTokens = await getCollection(wallet);

  // let walletData = await infoReader.methods.walletBalances(wallet).call();
  let walletData = {
    bulls: bapTokens?.genesis?.length || 0,
    teens: bapTokens?.teens?.length || 0,
    utilities: 0, // Temporarily empty, as we get utilities data from BAP API
  };
  let bullCount = walletData["bulls"];
  let teensCount = walletData["teens"];
  let utilitiesBalance = walletData["utilities"];

  let [{ genesis, gods }, teens, utilities, botb, partners, apes, clues] =
    await Promise.all([
      fetchGenesis(bapTokens.genesis, bullCount),
      fetchTeens(bapTokens.teens, teensCount),
      fetchUtilities(utilitiesBalance),
      fetchBotbTokens(),
      fetchPartnerTokens(),
      fetchApes(),
      fetchClues(),
    ]);
  // Update Teens
  teens = teens.map((teen) => {
    if (
      utilities.methMachines.findIndex((maker) => maker.guild === teen.guild) >
      -1
    ) {
      return { ...teen, hasActiveMethMachine: !teen.isResurrected };
    }

    return teen;
  });

  return { botb, genesis, gods, teens, partners, apes, ...utilities, clues };
};

const getCollection = async function (wallet) {
  const response = await useAnyApi({ throw: true }).exec({
    baseURL: "https://api.roughryders.xyz/api",
    url: "/mint/tokens",
    method: "POST",
    data: {
      wallet,
    },
  });
  return response.nfts;
};
